// extract all variable keys from document data recursively
// parses <span data-type="mention" data-id="variableName"> mention nodes from HTML
export function extractVariables(data: Record<string, any>): string[] {
    const variableKeys = new Set<string>();
    const mentionRegex = /data-type="mention"\s+data-id="([^"]+)"/g;

    function walk(value: unknown) {
        if (typeof value === 'string') {
            for (const match of value.matchAll(mentionRegex)) {
                variableKeys.add(match[1].trim());
            }
        } else if (Array.isArray(value)) {
            value.forEach(walk);
        } else if (value && typeof value === 'object') {
            Object.values(value).forEach(walk);
        }
    }

    walk(data);
    return Array.from(variableKeys);
}

// add months to a YYYY-MM-DD string, clamping to end-of-month (e.g. Jan 31 + 1 → Feb 28)
export function addMonths(dateStr: string, months: number): string {
    const [yearStr, monthStr, dayStr] = dateStr.split('-');
    const year = Number(yearStr);
    const month = Number(monthStr);
    const day = Number(dayStr);

    // Day 0 of the month after the target gives the last day of the target month.
    // Date.UTC handles year rollover correctly when the month index exceeds 11.
    const lastDay = new Date(
        Date.UTC(year, month - 1 + months + 1, 0)
    ).getUTCDate();
    const d = new Date(
        Date.UTC(year, month - 1 + months, Math.min(day, lastDay))
    );
    return d.toISOString().substring(0, 10);
}
